// Fetch Data From AJAX
export const nxtdash_fetch_api = async (args) => {
    if (args) {        
        try {
            const response = await fetch(nxtext_ajax_object.ajax_url, {
                method: 'POST',
                body: args
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            return error.message;
        }
    } else {
        return false;
    }
}

// Form Append Data
export const appendFormData = (form, data) => {
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            form.append(key, data[key]);
        }
    }
};

export const nxtdash_install_theme = async (e, args, setNexterThemeIntall) => {
    e.target.innerHTML = '<span class="nxtext-loading-circle"></span>';
	try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
    
        if (data) {            
            setNexterThemeIntall(true)
            e.target.innerHTML = 'Installed';
            //window.location.reload();
        }
	  
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}
export const nxtdash_install_plugin = async (e, args, slug, setNxtOtherPluginInstall, nav) => {
    
    let loaderclass = 'nxt-white-loader';
    if(nav == 'more_products'){
        loaderclass = 'nxt-blue-loader';
    }else if(slug == 'uichemy'){
        loaderclass = 'nxt-black-loader';
    }
    e.target.innerHTML = `<span class="nxtext-loading-circle ${loaderclass}"></span>`;
    
	try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
    
        if (data) {     
            if(nav == 'welcome'){
                e.target.innerHTML = 'Installed';
                window.location.reload();
            }else{
                setNxtOtherPluginInstall((prevState) => ({
                    ...prevState,
                    [slug]: {
                        ...prevState[slug],
                        install: true,
                        active: false,
                    },
                }));
            }
        }
	  
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}

export const nxtInstallCall = async (e, reload = true, slug="" ,setInstalled = '') => {
    let ajxData = new FormData(),
        formData = {};

    Object.assign(formData, {
        action: 'nexter_ext_plugin_install',
        slug : slug,
        nexter_nonce: nxtext_ajax_object.ajax_nonce,
    });
    appendFormData(ajxData, formData);
    if(slug=='wdesignkit' && nxtext_ajax_object?.dashData?.wdkactive != '1'){
        e.target.innerHTML = 'Installing WDesignKit';
    }else if(slug=='wdesignkit' && nxtext_ajax_object?.dashData?.wdkactive == '1'){
        e.target.innerHTML = 'Activating WDesignKit';
    }else if(slug=='the-plus-addons-for-block-editor' && nxtext_ajax_object?.dashData?.tpgbactivate != '1'){
        e.target.innerHTML = 'Installing Nexter Blocks';
    }else if(slug=='the-plus-addons-for-block-editor' && nxtext_ajax_object?.dashData?.tpgbactivate == '1'){
        e.target.innerHTML = 'Activating Nexter Blocks';
    }else if(slug=='nexter-extension' && nxtext_ajax_object?.dashData?.extensionactivate != '1'){
        e.target.innerHTML = 'Installing Nexter Extension';
    }else if(slug=='nexter-extension' && nxtext_ajax_object?.dashData?.extensionactivate == '1'){
        e.target.innerHTML = 'Activating Nexter Extension';
    }
    
    try {
        const response = await nxtdash_fetch_api(ajxData);
        const data = await response;

        if (data) {
            setTimeout(() => {
                if(slug=='wdesignkit'){
                    e.target.innerHTML = 'Import Templates';
                }else if(slug=='the-plus-addons-for-block-editor'){
                    e.target.innerHTML = 'Activated Blocks';
                }else if(slug=='nexter-extension'){
                    e.target.innerHTML = 'Activated Extensions';
                }
            }, 2000);
            if(slug=='wdesignkit'){
                nxtext_ajax_object.dashData.wdadded= data.Success;

                if (typeof setInstalled === 'function') {
                    setInstalled(true);
                    nxtext_ajax_object.dashData.wdadded= data.Success;
                }
            }else if(slug=='the-plus-addons-for-block-editor'){
                nxtext_ajax_object.dashData.tpgbinstall = data.Success;
            }else if(slug=='nexter-extension'){
                nxtext_ajax_object.dashData.extensioninstall = data.Success;
            }
            
            if(reload){
                window.location.reload();
            }
            
        }
    } catch (error) {
        console.error('Error in Cache :', error);
    }
}

// Save Data 
export const nxtdash_save_data = async (e,args, callfun = '') => {    
	e.target.innerHTML = 'Saving...';

    let saveArgs = args;
    if (args.action && (args.action === 'tpgb_blocks_opts_save' || args.action === 'tpgb_custom_css_js_save' || args.action === 'tpgb_connection_data_save' || args.action === 'tpgb_white_label_save')) {
        saveArgs = new FormData();
	    appendFormData(saveArgs, args);
    }

	try {
		const response = await nxtdash_fetch_api(saveArgs),
        data = await response;
    
        if (data) {   
            
            if (args.action && args.action === 'tpgb_blocks_opts_save') {
                const enableNormalBlocks = JSON.parse(args.enable_normal_blocks || '{}');
                const tpExtraOption = JSON.parse(args.tp_extra_option || '{}');
        
                if (!nxtext_ajax_object.dashData || !Array.isArray(nxtext_ajax_object.dashData.enableBlock)) {
                    nxtext_ajax_object.dashData = nxtext_ajax_object.dashData || {};
                    nxtext_ajax_object.dashData.enableBlock = [];
                }
                
                nxtext_ajax_object.dashData.avtiveBlock = enableNormalBlocks.length
                nxtext_ajax_object.dashData.enableBlock = Array.from(
                    new Set([...enableNormalBlocks, ...tpExtraOption])
                );
        
            } else if (args.action && args.action === 'tpgb_connection_data_save') {
                const newData = JSON.parse(args.tpgb_connection_data || '{}');
        
                if (!Array.isArray(nxtext_ajax_object.dashData.extOption)) {
                    nxtext_ajax_object.dashData.extOption = [{}];
                }
        
                const existingData = nxtext_ajax_object.dashData.extOption || {};
                const updatedData = { ...existingData, ...newData };
        
                nxtext_ajax_object.dashData.extOption = updatedData;
            }else if (args.action && args.action === 'tpgb_custom_css_js_save') {
                const ctmCss = args.tpgb_custom_css_editor;
                const ctmJs = args.tpgb_custom_js_editor;

                if (!nxtext_ajax_object.dashData.customCode) {
                    nxtext_ajax_object.dashData.customCode = {};
                }
                nxtext_ajax_object.dashData.customCode.tpgb_custom_css_editor = ctmCss;
                nxtext_ajax_object.dashData.customCode.tpgb_custom_js_editor = ctmJs;
                
            }else if (args.action && args.action === 'tpgb_white_label_save') {
                const whfield = args.fields;

                nxtext_ajax_object.dashData.whiteLabel = whfield
            }
            
            e.target.innerHTML = 'Done';
            if(callfun  && typeof callfun === "function"){
                setTimeout(callfun, 500)
            }

            setTimeout(() => {
                e.target.innerHTML = 'Save';
            }, 2000);
        }
	  
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}

export const nxtdash_save_simplefont = async (e,args, setDefaultSimple, setSimpleUniId, setSimpleFont, setIsContentDisabled) => {  
    e.target.innerHTML = 'Saving...';
	try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
    
        if (data) {            
            e.target.innerHTML = 'Done';
            setTimeout(() => {
                e.target.innerHTML = 'Save';
            }, 2000);
            setDefaultSimple('');
            setSimpleUniId('');
            setSimpleFont(false);
            setIsContentDisabled(true)
        }
	  
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}
export const nxtdash_save_variablefont = async (e,args, setDefaultVariable, setVariableUniId, setVariableFont, setIsContentDisabled) => {  
    e.target.innerHTML = 'Saving...';
	try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
    
        if (data) {            
            e.target.innerHTML = 'Done';
            setTimeout(() => {
                e.target.innerHTML = 'Save';
            }, 2000);
            setDefaultVariable('');
            setVariableUniId('');
            setVariableFont(false);
            setIsContentDisabled(true)
        }
	  
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}


export const nxtdash_remove_fonts = async (e, args) => {
    e.target.innerHTML = 'Removing...'; 
    try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
    
        if (data) {            
            e.target.innerHTML = 'Done';
            setTimeout(() => {
                e.target.innerHTML = 'Reset';
            }, 2000);
        }
	  
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}

export const extraOptionsSave = async (evt, key, opt) =>{
    let action_ajax = '', active_deactive = '';
    if(evt.target.checked == true){
        action_ajax = 'nexter_extra_ext_active';
        active_deactive = 'active';
    }else{
        action_ajax = 'nexter_extra_ext_deactivate';
        active_deactive = 'deactive';
    }

    const formData = new FormData();
    formData.append('action', action_ajax);
    formData.append('extension_type', key);
    formData.append('active_deactive', active_deactive); 
    formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce); 
    nxtdash_fetch_api(formData)
}

export const nxtReplaceBtnClick = async (e,args, setOpt, type) => {
    let popWrap = e.target.closest('.nxtext_settings_popup');
    let getMainW = popWrap.querySelector('.nxtext_field_card_cover');
    let getHead = popWrap.querySelector('.nxtext_popup_heading')
    
	try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
        if(data && getMainW && getHead){
            let getID = getMainW.getAttribute('id');
            if(getID == 'wp-replace-url'){
                getHead.insertAdjacentHTML('beforeend',replaceAlertMessage(data, type));
                if(data.data && data.data.result && data.data.result > 0){
                    if(type == 'replace'){
                        setOpt(true);
                    }
                }else{
                    if(type == 'replace'){
                        setOpt(false);
                    }
                }
                let toast = getHead.querySelector('.nxtext_toast_msg');
                if(toast){
                    setTimeout(()=>{
                        toast.classList.add('active')
                    }, 50)
                    setTimeout(()=>{
                        toast.classList.remove('active')
                    }, 2500)
                    setTimeout(()=>{
                        toast.remove()
                    }, 3000)
                }
            }        
        }
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}
/* Replace URL & Text Notice */
export const replaceAlertMessage = (data, type) => {
    let success = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 11 11" fill="none"><path d="M5.5 0C2.46742 0 0 2.46742 0 5.5C0 8.53258 2.46742 11 5.5 11C8.53258 11 11 8.53258 11 5.5C11 2.46742 8.53258 0 5.5 0ZM8.57394 4.05263L5.0589 7.5401C4.85213 7.74687 4.5213 7.76065 4.30075 7.55388L2.43985 5.8584C2.2193 5.65163 2.20551 5.30702 2.3985 5.08647C2.60526 4.86591 2.94987 4.85213 3.17043 5.0589L4.64536 6.40977L7.78822 3.26692C8.00877 3.04637 8.35338 3.04637 8.57394 3.26692C8.79449 3.48747 8.79449 3.83208 8.57394 4.05263Z" fill="#00C159"/></svg>`;

    let error = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 11 11" fill="none"><path d="M5.5 0C2.46735 0 0 2.46735 0 5.5C0 8.53265 2.46735 11 5.5 11C8.53265 11 11 8.53265 11 5.5C11 2.46735 8.53265 0 5.5 0ZM5.5 9.625C3.22556 9.625 1.375 7.77444 1.375 5.5C1.375 4.6319 1.63818 3.81124 2.1386 3.11098L7.88902 8.8614C7.18876 9.36182 6.3681 9.625 5.5 9.625ZM8.8614 7.88902L3.11098 2.1386C3.81124 1.63818 4.6319 1.375 5.5 1.375C7.77444 1.375 9.625 3.22556 9.625 5.5C9.625 6.3681 9.36182 7.18876 8.8614 7.88902Z" fill="#FF3939"></path></svg>`;

    let warning = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 11 11" fill="none"><path d="M10.8299 8.10099L6.62352 1.0165C6.39189 0.605156 5.97207 0.359375 5.49999 0.359375C5.02791 0.359375 4.60809 0.605156 4.37962 1.01115L0.16759 8.10634C-0.0596284 8.5098 -0.0555464 8.98943 0.17829 9.38911C0.411803 9.78878 0.827848 10.0273 1.29109 10.0273H9.70923C10.1725 10.0273 10.5885 9.78878 10.8221 9.38911C11.0559 8.98941 11.06 8.5098 10.8299 8.10099ZM6.14452 8.41602H4.85546V7.12695H6.14452V8.41602ZM6.14452 6.48242H4.85546V3.25977H6.14452V6.48242Z" fill="#F9B744"/></svg>`;
    
    let icon = '', message = '', title = '';
    if(data.success){
        if(data.data.result > 0){
            icon = success;
            title = 'Success';
        }else{
            icon = error;
            title = 'Oops';
        }
        message = (type == 'replace') ? data.data.result+' Result(s) Found' : data.data.result+' Result(s) Successfully Replace';
    }else{
        icon = warning;
        title = 'Warning';
        message = data.data.message;
    }

    return`<div class='nxtext_toast_msg'>
        ${icon}
        <div class='nxtext_toast_txt_cover'>
            <span class='nxtext_paragrph nxtext_toast_toph'>${title}</span>
            <span class='nxtext_paragrph'>${message}</span>
        </div>

        <svg class='nxtext_toast_close_icon' width="10" height="10" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.09999 1.90357C5.96999 1.77357 5.75999 1.77357 5.62999 1.90357L3.99999 3.53023L2.36999 1.90023C2.23999 1.77023 2.02999 1.77023 1.89999 1.90023C1.76999 2.03023 1.76999 2.24023 1.89999 2.37023L3.52999 4.00023L1.89999 5.63023C1.76999 5.76023 1.76999 5.97023 1.89999 6.10023C2.02999 6.23023 2.23999 6.23023 2.36999 6.10023L3.99999 4.47023L5.62999 6.10023C5.75999 6.23023 5.96999 6.23023 6.09999 6.10023C6.22999 5.97023 6.22999 5.76023 6.09999 5.63023L4.46999 4.00023L6.09999 2.37023C6.22666 2.24357 6.22666 2.03023 6.09999 1.90357Z" fill="#CCCCCC" />
        </svg>
    </div>`;
};


export const nxtAdobeFontGet = async (e,args, setOpt, setOptSetting) => {
    e.target.innerHTML = 'Checking...';
    let popWrap = e.target.closest('.nxtext_settings_popup');
    let getMainW = popWrap.querySelector('.nxtext_field_card_cover');
    
	try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
        if(data && getMainW){
            let getID = getMainW.getAttribute('id');
            if(data.data && data.data.settings){
                const updatedSettings = { ...setOpt };
                updatedSettings[getID].values = data.data.settings;
                setOptSetting(updatedSettings);           
            }else{
                getMainW.insertAdjacentHTML('beforeend',adobeAlertMessage());
                let toast = getMainW.querySelector('.nxtext_toast_msg');
                if(toast){
                    setTimeout(()=>{
                        toast.classList.add('active')
                    }, 50)
                    setTimeout(()=>{
                        toast.classList.remove('active')
                    }, 2500)
                    setTimeout(()=>{
                        toast.remove()
                    }, 3000)
                }
            }
            e.target.innerHTML = 'Done';
            setTimeout(() => {
                e.target.innerHTML = 'Save';
            }, 2000);
        }
	} catch (error) {
		console.error('Error In Save Data :', error);
	}
}

export const nxtRegenerateThumb = async (e, args, nonce, imageSize) => {
    e.target.innerHTML = 'Regenerating...';
    var regenerated_images_count = 0;
    try {
		const response = await nxtdash_fetch_api(args),
        data = await response;
        if(data && data.success && data?.data?.content?.attachment_ids){
            var attachment_ids = data?.data?.content?.attachment_ids || 0;
            if( attachment_ids.length != 0 ){
                e.target.innerHTML = 'Waiting for server to regenerate ' + attachment_ids.length + ' 	Images' ;
                setTimeout(function(){
                    if(attachment_ids.length < regenerated_images_count){
                        e.target.innerHTML = 'Hold On ' + attachment_ids.length + 'already regenerated'
                    }
                }, 1000);
                attachment_ids.forEach(function (attachment_id){
                    const formData = new FormData();
                    formData.append('action', 'nexter_regenerate_image_thumbnail_by_id');
                    formData.append('thumbnail_id', attachment_id);
                    formData.append('image_sizes_to_be_generated', imageSize);
                    formData.append('nexter_nonce', nonce);

                    const response2 = nxtdash_fetch_api(formData),
                    data2 = response2;

                    if(data2 && data2.success){
                        setTimeout(function(){
                            e.target.innerHTML = 'It will take few seconds to regenerate';
                        }, 3000);
                        regenerated_images_count++;
                        if((attachment_ids.length / 2 ) < regenerated_images_count ) {
                            e.target.innerHTML = 'About to complete';
                        }
                    }
                })
            }
        }
	} catch (error) {
		console.error('Error In Save Data :', error);
	}  
}


export const adobeAlertMessage = () => {
    let error = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 11 11" fill="none"><path d="M5.5 0C2.46735 0 0 2.46735 0 5.5C0 8.53265 2.46735 11 5.5 11C8.53265 11 11 8.53265 11 5.5C11 2.46735 8.53265 0 5.5 0ZM5.5 9.625C3.22556 9.625 1.375 7.77444 1.375 5.5C1.375 4.6319 1.63818 3.81124 2.1386 3.11098L7.88902 8.8614C7.18876 9.36182 6.3681 9.625 5.5 9.625ZM8.8614 7.88902L3.11098 2.1386C3.81124 1.63818 4.6319 1.375 5.5 1.375C7.77444 1.375 9.625 3.22556 9.625 5.5C9.625 6.3681 9.36182 7.18876 8.8614 7.88902Z" fill="#FF3939"></path></svg>`;

    return`<div class='nxtext_toast_msg'>
        ${error}
        <div class='nxtext_toast_txt_cover'>
            <span class='nxtext_paragrph nxtext_toast_toph'>Sorry!!!</span>
            <span class='nxtext_paragrph'>Please check your Project ID in adobe kit</span>
        </div>

        <svg class='nxtext_toast_close_icon' width="10" height="10" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.09999 1.90357C5.96999 1.77357 5.75999 1.77357 5.62999 1.90357L3.99999 3.53023L2.36999 1.90023C2.23999 1.77023 2.02999 1.77023 1.89999 1.90023C1.76999 2.03023 1.76999 2.24023 1.89999 2.37023L3.52999 4.00023L1.89999 5.63023C1.76999 5.76023 1.76999 5.97023 1.89999 6.10023C2.02999 6.23023 2.23999 6.23023 2.36999 6.10023L3.99999 4.47023L5.62999 6.10023C5.75999 6.23023 5.96999 6.23023 6.09999 6.10023C6.22999 5.97023 6.22999 5.76023 6.09999 5.63023L4.46999 4.00023L6.09999 2.37023C6.22666 2.24357 6.22666 2.03023 6.09999 1.90357Z" fill="#CCCCCC" />
        </svg>
    </div>`;
};